"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHashId = void 0;
const crypto_1 = __importDefault(require("crypto"));
const createHashId = (str) => crypto_1.default.createHash('sha256').update(str).digest('base64');
exports.createHashId = createHashId;
class ID {
    constructor(length = 8) {
        this.hasHash = false;
        this.length = 8;
        this.numbers = '0123456789';
        this.specials = '!@#$(%^&*)+=/';
        this['a-z'] = 'abcdefghijklmnopqrstuvwxyz';
        this['A-Z'] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        this.charSets = {
            numbers: this.numbers,
            specials: this.specials,
            'a-z': this['a-z'],
            'A-Z': this['A-Z'],
        };
        this.getRandomChar = (chars, inputChar) => {
            var _a, _b;
            let charArr = chars;
            if (inputChar) {
                let cs;
                const map = {
                    '/X': () => (cs = 'X'),
                    '%X': () => (cs = this['A-Z']),
                    '%n': () => (cs = this.numbers),
                    '%x': () => (cs = this['a-z']),
                    '%s': () => (cs = this['specials']),
                };
                (_a = map === null || map === void 0 ? void 0 : map[inputChar]) === null || _a === void 0 ? void 0 : _a.call(map);
                if (cs)
                    charArr = (_b = cs === null || cs === void 0 ? void 0 : cs.split) === null || _b === void 0 ? void 0 : _b.call(cs, '');
            }
            return charArr[Math.floor(Math.random() * charArr.length)];
        };
        this.length = length;
    }
    withOut(...charSetNames) {
        charSetNames === null || charSetNames === void 0 ? void 0 : charSetNames.forEach(cs => { var _a; return (_a = this.charSets) === null || _a === void 0 ? true : delete _a[cs]; });
        return this;
    }
    only(...charSetNames) {
        Object.keys(this.charSets || {}).forEach((cs) => {
            var _a;
            if (charSetNames === null || charSetNames === void 0 ? void 0 : charSetNames.includes(cs))
                return;
            (_a = this.charSets) === null || _a === void 0 ? true : delete _a[cs];
        });
        return this;
    }
    validChars(regex) {
        Object.entries(this.charSets || {}).forEach(([charSet, value]) => {
            var _a, _b;
            this.charSets[charSet] = (_b = (_a = [...(value || [])]) === null || _a === void 0 ? void 0 : _a.filter((v) => regex.test(v))) === null || _b === void 0 ? void 0 : _b.join('');
        });
        return this;
    }
    pattern(mask) {
        this.mask = mask;
        this.length = mask === null || mask === void 0 ? void 0 : mask.length;
        return this;
    }
    hash() {
        this.hasHash = true;
        return this;
    }
    generate() {
        var _a, _b, _c, _d;
        let id;
        let chars = (_b = (_a = Object.values(this.charSets)) === null || _a === void 0 ? void 0 : _a.map((i) => { var _a; return (_a = i === null || i === void 0 ? void 0 : i.split) === null || _a === void 0 ? void 0 : _a.call(i, ''); })) === null || _b === void 0 ? void 0 : _b.flat();
        if (this.mask) {
            id = (_c = this.mask) === null || _c === void 0 ? void 0 : _c.replace(/%(n|x|X|s)|\/X|X/g, c => this.getRandomChar(chars, c));
        }
        if (this.hasHash) {
            id = (0, exports.createHashId)(id + new Date().toUTCString());
        }
        if (!id)
            id = (_d = [...Array(this.length)]
                .fill('')) === null || _d === void 0 ? void 0 : _d.map(_ => this.getRandomChar(chars)).join('');
        return id;
    }
}
exports.default = ID;
